











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFooterIntegrateMenuRoot_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskFooterIntegrateMenu_task"
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node ).hash = "11cc69380d3176ddcea561996356ba4d";

export default node;
